
        import { registerPageAdapter } from '@lib/utils/pageAdapter';
        import {
            generateBrowseSchema,
            invokeSchema,
        } from '@lib/utils/schema';
        import {moneyName} from '@src/lib/utils/tools';

        const initPage = async () => {
            await registerPageAdapter({
                openThemeAdapter: true,
                openFontAdapter: true,
                // 该页面rem规则和默认的不一致，其他页面按需使用该属性
                closeRemAdapter: true
            });
            document.getElementById('app').style.visibility = 'visible';
        };
        initPage();
        var docEl = document.documentElement;
        var clientWidth = docEl.clientWidth;
        if (clientWidth) {
            docEl.style.fontSize = clientWidth >= 600 ? '100px' : 100 * (clientWidth / 414) + 'px';
        }
        const jumpUrl = function (e) {
            if (e?.target?.nodeName === 'A') {
                e.stopImmediatePropagation();
                e.preventDefault();
                const url = e.target.href;
                const title = e.target.innerHTML || '';
                const pageUrl = window.location.href;
                const urlObject = new URL(pageUrl);
                const searchParams = urlObject.searchParams;
                if (searchParams.get('from') === 'popover') {
                    window.location.href = url;
                } else {
                    const schema = generateBrowseSchema({
                        url,
                        title,
                    });
                    invokeSchema(schema);
                }
            }

        }
        document.addEventListener('click', e => jumpUrl(e), true);
        const descName = moneyName();

        const content = `
            <div class="content">
            <h1><strong>文心用户协议</strong></h1>

            <p>欢迎您使用“文心”软件（下称“文心”）及相关服务（下称“本服务”）！本用户协议是由北京百度网讯科技有限公司及其关联公司（以下简称“百度”，“我们”）与您就注册、登录、使用文心及相关服务所订立的协议。</p>
            <p><strong>使用本服务即表示您通过电子方式确认本协议内容，同意本协议约束。</strong>如果您或您的监护人不同意本协议的任何内容，您应该立即停止使用“文心”服务。如您未经监护人同意使用本服务，则您及您的监护人应依法承担因此导致的一切后果。
            </p>
            <p>我们特别提醒您在使用本服务之前认真阅读（未成年人应在法定监护人陪同下阅读）、充分理解本协议的全部条款，尤其是服务使用规范、免责声明、法律管辖与适用等条款。除非您接受本协议的全部条款，否则您无权注册、登录或使用本服务。<strong>您的注册、登录、使用等行为将视为您对本协议的接受，并视为您接受并遵守本协议各项条款。</strong>
            </p>
            <h2>第1条 定义</h2>
            <p>1.1用户：指使用“文心”的所有使用者。本协议中可称为“用户”或“您”。为避免疑义，百度文心生态合作伙伴使用本服务的，属于本协议下的“用户”，需遵守本协议约定。</p>
            <p>1.2“文心”：指我们依托百度文心大模型等大语言模型能力，以网页、APP、PC客户端以及后续随技术发展出现的创新形态方式向用户提供基于人工智能的相关服务的产品，基于跨知识领域和自然语言理解能力，通过产品化的功能和页面，帮助启发用户灵感、辅助进行创作，包括但不限于根据您输入的问题，为您返回输出人工智能生成内容（以下简称“生成内容”），分享您的创意等。百度致力于持续改进并优化服务，据此我们保留在未来因业务发展、品牌调整等原因修改本产品的名称和/或标识的权利，具体以实际展示为准，该等名称的任何变更不会影响本规则的有效性。
            </p>
            <p>1.3输入：指用户在使用文心及相关服务期间，向文心及相关服务提交的文本、音频、图像或其他内容和信息。</p>
            <p>1.4输出：指文心及相关服务响应用户输入而生成的包括但不限于文字、表格、代码、图片、视频等内容和信息。</p>

            <h2>第2条 服务介绍及软件的获取、安装、卸载和更新</h2>
            <p>2.1“文心”依托百度文心大模型等大语言模型技术，提供人工智能问答服务。用户输入内容和信息，“文心”会基于用户的输入，输出相应的内容作为响应，包括文字、表格、代码、图片和视频等。“文心”会收集和分析用户的输入和输出信息，以提高识别和响应能力，改进本服务的智能性和内容质量。用户可对输出进行评价，包括点赞、踩等操作，以反馈用户对“文心”输出信息的意见。文心使用的大语言模型及算法备案的公示信息如下：
            </p>
            <p>
            <table border="1" cellspacing="0" cellpadding="0">
                <thead>
                    <tr>
                        <th>
                            <p><b>备案类型</b></p>
                        </th>
                        <th>
                            <p><b>算法/模型名称</b></p>
                        </th>
                        <th>
                            <p><b>备案号</b></p>
                        </th>
                        <th>
                            <p><b>公示信息链接</b></p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <p>生成式人工智能服务备案</p>
                        </td>
                        <td>
                            <p>文心一言</p>
                        </td>
                        <td>
                            <p>Beijing-WenXinYiYan-20230821</p>
                        </td>
                        <td><a href="https://www.cac.gov.cn/2024-04/02/c_1713729983803145.htm"
                                target="_blank">https://www.cac.gov.cn/2024-04/02/c_1713729983803145.htm</a></td>
                    </tr>
                    <tr>
                        <td>
                            <p>深度合成服务算法备案</p>
                        </td>
                        <td>
                            <p>百度文生图内容生成算法</p>
                        </td>
                        <td>
                            <p>网信算备110108645502801230019号</p>
                        </td>
                        <td><a href="https://www.cac.gov.cn/2023-06/20/c_1688910683316256.htm"
                                target="_blank">https://www.cac.gov.cn/2023-06/20/c_1688910683316256.htm</a></td>
                    </tr>
                    <tr>
                        <td>
                            <p>深度合成服务算法备案</p>
                        </td>
                        <td>
                            <p>文心大模型算法</p>
                        </td>
                        <td>
                            <p>网信算备110108645502801230035号</p>
                        </td>
                        <td><a href="https://www.cac.gov.cn/2023-09/01/c_1695224377544009.htm"
                                target="_blank">https://www.cac.gov.cn/2023-09/01/c_1695224377544009.htm</a></td>
                    </tr>
                    <tr>
                        <td>
                            <p>深度合成服务算法备案</p>
                        </td>
                        <td>
                            <p>DeepSeek大语言模型算法</p>
                        </td>
                        <td>
                            <p>网信算备110108970550101240011号</p>
                        </td>
                        <td><a href="https://www.cac.gov.cn/2024-04/11/c_1714509267496697.htm"
                                target="_blank">https://www.cac.gov.cn/2024-04/11/c_1714509267496697.htm</a></td>
                    </tr>
                </tbody>
            </table>
            </p>
            <p>2.2就“文心”App、相关客户端等软件，百度公司给予您一项个人的、可撤销的、不可转让及非排他性的许可。您仅可为访问或使用本服务的目的而使用该软件及服务。</p>
            <p>本服务中“文心”提供包括但不限于iOS、Android、HarmonyOS等多个应用版本，您必须选择与所安装终端设备相匹配的软件版本。</p>
            <p>2.3您在使用本服务某一特定功能时，针对该特定功能可能会另有单独的协议、相关业务规则等（“具体协议”），您在使用该项特定功能前请阅读并同意相关的具体协议。例如您使用${descName}及相关功能，需遵守<a
                    href="https://yiyanapp.baidu.com/talk/recharge-rule">《${descName}充值协议》</a>。本协议与具体协议的内容存在冲突的，以具体协议的规定为准。</p>
            <p>2.4您在使用本服务中由第三方（比如通过智能体、链接等）提供的产品或服务时，请遵守第三方公布的用户协议、使用规则、隐私政策等法律文件，在法律法规允许的范围内，我们无法对第三方产品及任何内容负责。</p>
            <p>2.5本服务具体功能将随着用户反馈、技术升级，或相关监管政策的变化不断迭代更新。</p>
            <p><strong>2.6软件的获取</strong></p>
            <p>2.6.1您可以直接从百度公司的网站上或终端设备官方应用商店、第三方应用商店获取本软件，也可以从得到百度公司授权的其他第三方获取。</p>
            <p>2.6.2如果您从未经百度公司授权的第三方获取本软件或与本软件名称相同的安装程序，百度公司无法保证该软件能够达到正常使用的效果，并不承担因此给您造成的损失</p>
            <p><strong>2.7软件的安装与卸载</strong></p>
            <p>2.7.1百度公司可能为不同的终端设备开发了不同的软件版本，您应当根据实际情况选择下载合适的版本进行安装。</p>
            <p>2.7.2下载安装程序后，您需要按照该程序提示的步骤正确安装。</p>
            <p>2.7.3如果您不再需要使用文心或者需要安装新版软件，可以卸载我们的软件。如果您愿意帮助百度公司改进产品服务，您可以告知我们卸载的原因，十分感谢您对百度产品提出的意见、建议。</p>
            <p><strong>2.8软件的更新</strong></p>
            <p>2.8.1为了改善用户体验、完善服务内容，百度公司将不断努力开发新的服务，并为您不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。</p>
            <p>2.8.2为了保证本软件及服务的安全性和功能的一致性，百度有权不经向你特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。</p>
            <p>2.8.3本软件新版本发布后，旧版本的软件可能无法使用。百度不保证旧版本软件继续可用及相应的客户服务，请你随时核对并下载最新版本。</p>

            <h2>第3条 账号登录</h2>
            <p>3.1为符合相关法律法规，“文心”某些功能仅为实名注册并登录的用户提供服务。如果您已经拥有百度账号，您可以直接登陆并使用“文心”，如果您尚未注册百度账号，可直接前往passport.baidu.com网站进行注册，
                或根据“文心”内部引导进行注册并使用。您可以通过“文心”提供的第三方联合登录服务使用“文心”。账号注册过程中，
                您应当同意<a href="https://passport.baidu.com/static/passpc-account/html/protocal.html"
                    target="_blank">《百度用户协议》</a><a href="https://privacy.baidu.com/policy"
                    target="_blank">《百度隐私政策》</a>的条款并按照页面上的提示完成全部的注册程序。您注册成功后，百度公司将给予您一个用户帐号及相应的密码，该用户帐号和密码由您自己负责保管，登录时也可以采用手机号短信验证码的方式登录，请您保管好账号、密码和验证码；用户应当对以其用户帐号进行的所有活动和事件负法律责任。您使用百度账号上传与分享您发布的内容，应遵守相关规则、制度。
            </p>
            <p>3.2本服务主要面向成人。如果您未满18周岁，请在法定监护人陪同下阅读本协议，并在征得法定监护人的同意后使用本服务。百度充分理解保护未成年人的重要性，并会根据法律法规的要求及行业主流实践采取相应的保护措施。与此同时，请监护人合理引导和约束未成年人用户对本服务的使用，共同营造良好网络环境，帮助未成年人养成良好上网习惯，避免过度依赖或者沉迷本服务。
            </p>
            <p>3.3您理解并承诺，您所设置的账号不得违反国家法律法规相关规定，您的账号名称、头像和简介等注册信息及其他个人信息中不得出现违法和不良信息，未经他人许可不得用他人名义（包括但不限于冒用他人姓名、名称、字号、头像等足以让人混淆的方式）开设账号，不得恶意注册账号（包括但不限于频繁注册、批量注册账号等行为）。您在账号注册及使用过程中需遵守相关法律法规，不得实施任何侵害国家利益、损害其他公民合法权益、有害社会道德风尚的行为。百度有权对您提交的信息进行审核。
            </p>
            <p>3.4为符合相关法律法规的要求，保障您的账号安全，百度可能会定期或不定期采用不同的方式对您的身份进行验证，包括但不限于要求输入验证码、手机号验证、邮箱认证等。如您无法完成验证或拒绝验证的，百度可合理怀疑您的账号存在安全风险，并暂停向您提供本服务的部分或全部服务，并有权采取进一步措施。
            </p>
            <p>3.5由于相关法律法规要求，您的账号仅限您本人使用，不可转让、赠与、继承或授权第三方使用。如百度公司判断您账号的使用可能违反法律法规、危及您的账号安全及/或百度公司信息安全的，百度公司可拒绝提供相应服务或终止本协议。百度公司有权视情况封禁或注销、回收该账号，由此带来的包括但不限于内容、虚拟财产清空等损失由您本人及该账号使用者自行承担。本服务对用户认定标准为：同一百度账号、手机号、支付账号、银行卡号等均视为一个用户。
            </p>
            <p>3.6<b>您应该自行保管好您的账号信息。因您对账号信息保管不当、主动泄露或遭受他人攻击、诈骗等行为导致的损失及后果，均由您自行承担。</b>如发现任何未经授权使用您账号登录使用本服务或其他可能导致您账号遭窃、遗失的情况，建议您立即通知百度。<b>您理解百度对您的请求采取行动需要合理时间，除百度存在过错外，百度对在采取行动前已经产生的后果不承担责任。</b>
            </p>
            <p>3.7您可以随时注销您的账号并终止与百度的服务关系，但请您理解，即使您的账号已注销，您仍需承担与您账号相关的所有义务。特别地，在您注销账号前，您应确保账号不存在未完结交易或其他未了结的权利义务，且不存在其他因注销可能引发纠纷或者导致已发生的纠纷难以解决的情况，包括但不限于您的账号被冻结、限制，您的注销是出于躲避调查取证的目的等。请注意，若我们发现您在使用本服务过程中存在违法行为，我们将依法保存该等记录。
            </p>
            <p>3.8如您的账号有余额，请提出或转出账号内全部余额。特别提醒您，一旦您注销本服务账号，如届时该账号下还存在虚拟收益的（包括但不限于积分、虚拟货币、已经购买但未到期或未使用完的增值服务等），百度有权对该账号下的全部虚拟收益做清除处理，因此产生的后果由您自行承担。
            </p>
            <p>3.9百度发现账号使用者并非账号初始注册人时，有权暂停向用户提供本服务的部分或全部服务，并有权采取进一步措施。<b>您不应将账号或密码转让、出借、销售或以任何脱离您控制的形式交由他人使用，您对使用您的账号发生的所有活动负责，且转让、出借账号导致的任何后果均由您本人承担。</b>
            </p>


            <h2>第4条 服务使用规范 </h2>
            <p><strong>4.1基于您对本服务的使用，百度许可您一项个人的、基于法定或约定事由可撤销的、不可转让的、非独占的和非商业的使用本服务进行内容输入并获得内容输出的权利。如果您对外发布和传播本服务下输出时，您应当以显著方式标识该输出系由百度“文心”生成。本协议未明示授权的其他一切权利仍由百度保留，您在行使该些权利前须另行获得百度的书面许可，同时百度如未行使前述任何权利，并不构成对该权利的放弃。</strong>
            </p>
            <p>4.2在使用百度提供的上述服务时，应遵守本协议，遵守自愿、平等、公平及诚实信用原则，不利用本服务侵犯他人合法权益及谋取不正当利益，不扰乱互联网平台正常秩序。</p>
            <p><strong>4.3为履行法定合规要求，百度有权采取技术手段或人工手段对用户使用本服务的行为及信息进行审查，包括但不限于对输入和输出进行审查、建立风险过滤机制、建立违法内容特征库等。对于违规用户，百度有权按照本协议第八条的规定进行处置。</strong>
            </p>
            <p><strong>4.4百度提示您，作为本服务的使用者，您在使用上述服务时应积极承担信息安全义务。您输入、输出/生成、制作、评论、上传、发布、传播的信息应自觉遵守法律、行政法规，遵守公共秩序，尊重社会公德和伦理道德、社会主义核心价值观、国家利益、尊重他人合法权益、道德风尚和信息真实性等“七条底线”要求，否则百度有权立即采取相应处理措施。您承诺不对本服务采取以下行为：</strong>
            </p>
            <p>4.4.1诱导生成违反相关法律法规的输出，包括但不限于：</p>
            <p>(1)反对宪法所确定的基本原则。</p>
            <p>(2)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一。</p>
            <p>(3)损害国家荣誉和利益。</p>
            <p>(4)煽动民族仇恨、民族歧视，破坏民族团结。</p>
            <p>(5)侮辱、滥用英烈形象，否定英烈事迹，美化粉饰侵略战争行为的。</p>
            <p>(6)破坏国家宗教政策，宣扬邪教和封建迷信。</p>
            <p>(7)散布谣言，扰乱社会秩序，破坏社会稳定。</p>
            <p>(8)宣扬淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪。</p>
            <p>(9)煽动非法集会、结社、游行、示威、聚众扰乱社会秩序。</p>
            <p>(10)诽谤他人，泄露他人隐私，侵害他人名誉权、肖像权、隐私权、知识产权和其他合法权益。</p>
            <p>(11)破坏国际关系以及国际和平稳定。</p>
            <p>(12)含有法律、行政法规禁止的其他内容的信息。</p>
            <p>4.4.2诱导生成不友善对话的输出，包括但不限于：</p>
            <p>(1)人身攻击及辱骂他人。</p>
            <p>(2)针对以下群体发表诅咒、歧视、漠视生命尊严等性质的言论，群体包括：不同特定国籍、地域、性别、性别认同、性倾向、种族、民族、健康状况、职业、年龄、信仰、残障群体等。</p>
            <p>(3)对他人进行诅咒、恐吓或威胁。</p>
            <p>(4)对其他用户创作的内容直接进行贬低性的评论。</p>
            <p>(5)对其他用户使用粗俗用语，并产生了冒犯。</p>
            <p>(6)针对以下群体发表偏见性质的言论，群体包括：特定国籍、地域、性别、性别认同、性倾向、种族、民族、健康状况、职业、年龄、信仰、残障群体等。</p>
            <p>4.4.3恶意对抗本服务的过滤机制，包括但不限于：</p>
            <p>(1)输入难以辨识涵义影响阅读体验的字符、数字等无意义乱码。</p>
            <p>(2)恶意对抗行为，包括但不限于使用变体、谐音等方式规避服务检测来输入违反上述4.4.1和4.4.2的言论。</p>
            <p>4.4.4干扰本服务正常运行以及损害百度合法权益，包括但不限于：</p>
            <p>(1)利用本服务从事窃取商业秘密、窃取个人信息等违法犯罪活动。</p>
            <p>(2)利用本服务制作、发布、传播虚假信息、违法信息。</p>
            <p>(3)对本服务进行反向编译、反向工程或者以其他任何途径获得与本服务算法相关的任何信息。</p>
            <p>(4)利用本服务开发与本服务存在竞争关系其他产品和服务（除非该限制违反相关法律规范）。</p>
            <p>(5)以任何方式（包括但不限于通过任何机器人、蜘蛛、其他自动设置、设置镜像）来抓取、复制本服务及其所包含的任何内容。</p>
            <p>(6)未经百度同意或未有合法正当依据，擅自去除、篡改本服务涉及的深度合成内容显式标记。</p>
            <p>(7)将有关干扰、破坏或限制任何计算机软件、硬件或通讯设备功能的软件病毒或其他计算机代码、档案和程序之资料，加以上载、发布、发送电子邮件或以其他方式传送。</p>
            <p>(8)非法入侵本服务服务器、篡改本服务之相关代码或其他损害本服务的行为。</p>
            <p>(9)企图规避百度平台的安全设置或网络系统，包括获取用户不应获取的数据，登录未经明确授权的服务器或账号，或采用运行端口扫描等方式窥探其他网络的安全措施。</p>
            <p>(10)以导致百度的计算机系统或设施承受不合理负载的方式获取输出，或进行可能导致此类情况出现的行为。</p>
            <p>(11)未经百度授权，非法转售或对外提供文心服务，或以商业化目的使用文心服务。</p>
            <p>(12)破坏、绕开账号名额候选机制、实施任何形式的网络监控，从而截取与自身无关的信息。</p>
            <p>4.4.5其他违反法律法规规定、侵犯他人以及百度合法权益的行为。</p>
            <p>4.5百度公司会根据您选择的服务类型向您提供相应的服务。您理解并同意，基于用户体验或“文心”的运营安全、平台规则要求及健康发展等综合因素，百度公司有权选择提供服务或开展合作的对象，有权决定功能开放、数据接口和相关数据披露的对象和范围，并有权视具体情况中止或终止向存有包括但不限于以下情形的用户提供本服务：
            </p>
            <p>（1）违反法律法规或本协议规定的；</p>
            <p>（2）影响使用者体验的；</p>
            <p>（3）存在安全隐患的；</p>
            <p>（4）违背“百度”移动应用平台运营原则，或不符合百度公司其他管理要求的。</p>
            <p>4.5.1服务用途限制：本服务的生成内容仅供您为个人学习、娱乐使用。若涉及对您或者相关方可能产生重大影响的情形（例如法律、医疗、金融等相关专业场景或领域），本服务不能替代领域专业人员向您提供解答，相关观点仅供您参考。您根据生成内容所作出的任何判断或者据此作出的后续相关操作行为，其后果均由您自行承担。请审慎理性和依法使用本服务。
            </p>
            <p>4.5.2基于大语言模型和人工智能的技术特性，本服务生成内容存在随机性且无法保证唯一性，因此，您理解并同意我们可能会向不同用户输出相同或相似的生成内容。</p>
            <p>4.6我们提供基于人工智能技术生成内容服务。我们将依据相关法律法规要求在生成内容中添加人工智能生成标识，包括对生成内容添加肉眼可见的显式标识，以及通过特定技术手段在生成内容的文件元数据中添加隐式标识，向用户提示内容生成情况。
            </p>
            <p>请您仔细阅读并了解国家相关法律法规及强制性标准中有关标识合规要求，如《人工智能生成合成内容标识办法》、《网络安全技术
                人工智能生成合成内容标识办法》等（如法律法规及强制性标准有修订或新增，请按照修订后内容或新增内容执行）。</p>
            <p>为保证合法合规以及避免侵权，您在使用网络信息内容传播服务发布生成合成内容的，应当主动声明并使用我们提供的标识功能进行标识。您注意不使用或试图使用技术措施或其他手段删除、篡改、伪造、隐匿生成合成内容标识，不为特人实施上述行为提供工具或服务，不会通过不正当标识手段损害他人合法权益。
            </p>
            <p>如果您在生成内容的导出/下载过程中要求删除我们已标注的显式标识，则请您自觉依照法律要求传播、使用该内容，您使用该生成内容的行为及产生的后果由您个人负责。同时，我们会依据相关法律法规要求留存相关日志至少六个月。
            </p>


            <h2>第5条 知识产权和其他权利</h2>
            <p>5.1百度为“文心”及本服务的开发、运营主体，并对本服务的开发和运营等过程中产生的所有数据、信息、输出等享有法律法规允许范围内的全部权利，但相关权利人依照法律规定应享有权利的除外。</p>
            <p>5.2百度在“文心”及本服务中提供的内容（包括但不限于软件、技术、程序、代码、用户界面、网页、文字、图片、图像、音频、视频、图表、版面设计、商标、电子文档等）的知识产权（包括但不限于著作权、商标权、专利权和其他知识产权）属于百度所有，但相关权利人依照法律规定应享有权利的除外。
            </p>
            <p><strong>5.3您理解并承诺，您在使用本服务时的输入不侵犯任何人的知识产权、肖像权、名誉权、荣誉权、姓名权、隐私权、个人信息权益等合法权益，不涉及任何国家秘密、商业秘密、重要数据或其他可能会对国家安全或者公共利益造成不利影响的数据，否则由此产生的侵权风险和责任由您承担。百度由此遭受的全部直接和间接损失（包括但不限于经济、商誉、维权支出、律师费等损失）也同样由您承担。</strong>
            </p>
            <p><strong>5.4您知悉、理解并同意，如果您按照法律规定对您的输入（包括您使用本服务过程中自行上传、发布的全部内容）和/或输出享有权利的（包括但不限于知识产权、肖像权等），您使用本服务均不会造成前述合法权利的转移或减损，除非我们与您另有约定。与此同时，您理解并同意百度将在法律允许的范围内为实现本服务目的对您上传、发布的内容进行存储及使用（包括但不限于复制、分发、传送、公开展示、编辑等）。</strong>
            </p>
            <p><strong>5.5
                    基于大语言模型和人工智能的技术特性，本服务生成内容存在随机性且无法保证唯一性，因此，您理解并同意我们可能会向不同用户输出相同或相似的生成内容。由其他⽤户输⼊并为其他⽤户输出的内容，不应被视为您的内容。</strong>
            </p>
            <p><strong>5.6
                    服务用途限制：本服务的生成内容仅供您为个人学习、娱乐使用。若涉及对您或者相关方可能产生重大影响的情形（例如法律、医疗、金融等相关专业场景或领域），本服务不能替代领域专业人员向您提供解答，相关观点仅供您参考。您根据生成内容所作出的任何判断或者据此作出的后续相关操作行为，其后果均由您自行承担。请审慎理性和依法使用本服务。</strong>
            </p>

            <h2>第6条 隐私政策</h2>
            <p>6.1非常重视对用户个人信息的保护。百度将按照《文心个人信息保护规则》的规定收集、使用、储存和分享您的个人信息。《文心个人信息保护规则》为本协议不可分割的组成部分。</p>

            <h2>第7条 服务费用</h2>
            <p>7.1文心服务为免费服务，本服务的任何免费功能和服务不应视为百度放弃后续收费的权利。</p>
            <p>7.2对于暂不收费的功能，百度有权根据实际情况对暂不收费的服务内容、服务期限及服务标准等进行单方变更，用户对此理解并接受前述的变更。</p>
            <p>7.3前述修改、变更或开始收费前，百度将在相应服务页面进行通知或公告。</p>

            <h2>第8条 违约责任</h2>
            <p><strong>8.1因用户违反相关法律法规或本协议约定导致的任何后果，均由用户独立承担责任、赔偿损失，与百度无关。若因用户使用本服务的行为给百度或与百度公司合作的其他单位面临任何投诉、举报、质询、索赔、诉讼，或者使百度公司或者与百度公司合作的其他单位因此遭受任何名誉、声誉或者财产上的损失，您应积极地采取一切可能采取的措施，以保证百度公司及与百度公司合作的其他单位免受上述索赔、诉讼的影响。同时您对百度公司及与百度公司合作的其他单位因此遭受的直接及间接经济损失负有全部的损害赔偿责任。</strong>
            </p>
            <p><strong>8.2如果用户以任何手段干扰本服务的运行或干扰其他用户对本服务的使用的，百度有权要求其赔偿损失（包括但不限于经济、商誉、维权支出、律师费等损失）。</strong></p>
            <p><strong>8.3如果用户有上述违反“第4条
                    服务使用规范”行为的，百度有权采取警示、限制功能、暂停或终止提供服务、删除违法违规信息、锁定账号等百度认为合理的处理措施，并保存有关记录。对处理结果存在疑议的，用户可根据9.2条之规定向我们进行申诉，我们将及时受理并进行处理和反馈。</strong>
            </p>
            <p><strong>8.4百度依第8.3条采取限制功能、暂停或终止提供服务等处理措施的，根据处理措施的不同，用户可能短期或长期无法使用文心服务。</strong></p>

            <h2>第9条 第三方软件、产品或服务</h2>
            <p>9.1本服务可能包含第三方软件、产品或服务（例如本服务基于本地部署模型向您提供的第三方大语言模型服务，您可在本服务界面选择相应模型进行使用，具体以本服务界面提供及您实际选择的为准），受其相关协议或其他文件的约束，我们对此不承担责任。如因本服务使用的第三方软件、产品或服务引发的任何纠纷，应由该第三方负责解决，百度公司不承担任何责任。如果您没有遵守第三方软件、产品或服务的相关要求，该第三方或者国家机关可能会对您提起诉讼、罚款或采取其他制裁措施，并要求百度公司给予协助，您应当自行承担法律责任。
            </p>
            <p>9.2本服务生成内容可能包含第三方网站链接，此类链接仅是出于为您提供访问便利，您访问第三方网站及后续的操作行为与我们无关，我们不对第三方网站的内容或服务负责。请您审慎访问，注意查阅其协议或文件并保护好您的信息及财产安全。
            </p>
            <p style="word-break:break-all;">9.3本服务涉及对DeepSeek
                开源大模型的提供与使用，DeepSeek系列开源大模型由深度求索（DeepSeek）公司提供，其版权声明为Copyright (c) 2023
                DeepSeek（https://huggingface.co/deepseek-ai）；使用DeepSeek系列大模型需要严格遵守其开源许可证，包括代码许可证（https://huggingface.co/deepseek-ai/DeepSeek-V3/blob/main/LICENSE-CODE）、模型许可证（https://huggingface.co/deepseek-ai/DeepSeek-V3/blob/main/LICENSE-MODEL），特此鸣谢深度求索公司与DeepSeek开源社区对大模型开源及相关研究的贡献。
            </p>

            <h2>第10条 投诉、申诉处理 </h2>
            <p>10.1投诉。如果您认为本服务涉及侵害您知识产权或其他权利的，您可以书面的通讯方式，将相关投诉材料发送至该邮箱：appwenxin@baidu.com。我们会在收到您的投诉材料后进行处理。投诉内容中，还请您务必包括（1）权利人的姓名（名称）、联系方式和地址；（2）权利人享有权利的权属证明材料；（3）涉嫌侵权内容在信息网络上的位置（如指明您举报的含有侵权内容的出处，即：指网页地址或网页内的位置），以便我们与您举报的含有侵权内容的网页的所有权人/管理人联系；（4）构成侵犯权利人合法权益的初步证明材料。
            </p>
            <p>10.2申诉。如果您认为我们不恰当地限制了您使用本服务的能力，您可以将相关申诉材料发送至该邮箱：appwenxin@baidu.com。申诉所需的材料至少包括您的账号信息、身份信息、账号当前状态、账号因何种使用情形被采取措施以及您希望我们采取何种措施恢复您使用本服务的能力。您提交申诉申请后，我们将向您发送回执编号。您须记录回执编号以用于进度查询。申诉结果我们将以邮件方式通知您。
            </p>

            <h2>第11条 免责声明 </h2>
            <p><strong>11.1百度以“现状”、“当前功能”的状态提供本服务。百度不承担除法律有明确规定外的其他责任，如：不保证本服务在操作上不会中断或没有错误，不保证在现有技术水平下有能力纠正本服务的所有缺陷，亦不保证本服务能满足用户的所有要求。百度将在现有技术的基础上尽最大努力提供相应的安全措施以保障本服务的安全和正常运行，包括但不限于通过限制用户单次可发送的服务器请求数量。在特定时间段内用户的请求数量达到风险预警上限后，基于服务运营安全的考虑，您的账号可能会被暂停。</strong>
            </p>
            <p><strong>11.2鉴于网络服务和人工智能服务的特殊性，您知晓并同意“文心”随时变更、中断或终止部分或全部的网络服务。如变更、中断或终止的网络服务属于免费网络服务，“文心”无需通知用户，也无需对任何用户或任何第三方承担任何责任。</strong>
            </p>
            <p><strong>11.3由于可能存在的计算机病毒、网络通讯故障、系统维护等方面的因素以及可能发生的不可抗力事件或意外事件，百度在此明确声明对本服务不作明示或暗示的保证，包括对本服务的可适用性、没有错误或疏漏、持续性、准确性、可靠性、适用于某一特定用途或满足用户的需求、使用效果等。</strong>
            </p>
            <p><strong>11.4限于技术特性，百度在尽到合理努力的前提下，仍无法完全保证您通过本服务获得的输出的合法性、真实性、准确性以及完整性。您应对本服务中的输出自行加以判断，并承担因使用内容引起的所有风险。我们提示您，除法律有明确规定外，百度无法也不会对前述风险而导致的任何损失或损害承担责任。</strong>
            </p>
            <p><strong>11.5本服务下的输出不代表专业意见，不能代替如法律、医疗、金融等专业领域从业人员向您解答对应疑问，不应视为互联网新闻信息。相关观点也仅限于算法所触达有限数据呈现的供您参考的结果，并不代表百度立场。由于机器学习特性，就相同的输入可能产生不同的输出结果，请您注意甄别。</strong>
            </p>
            <p><strong>11.6在任何情况下，即使公司已被告知此类损害的可能性，公司或关联公司均不对任何直接、间接、后果性、惩罚性、偶然性、附带性、特殊性、后果性或刑罚性、惩戒性的损害承担责任，包括但不限于因您使用文心及相关服务而遭受的利润损失、商誉损失、数据损失或其他损失。除法律法规另有明确规定外，公司对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您在责任产生前12个月内为引起索赔的服务支付给公司的费用(如有)。</strong>
            </p>

            <h2>第12条 法律管辖和适用</h2>
            <p>12.1协议的订立、执行和解释及争议的解决均应适用中华人民共和国大陆地区法律。</p>
            <p><strong>12.2本协议的签订、履行或解释发生争议，双方应努力友好协商解决。如协商不成，任何一方均有权向北京百度网讯科技有限公司住所地有管辖权的法院起诉。</strong></p>

            <h2>第13条 本协议的更新与终止</h2>
            <p>13.1您对本协议的接受包括接受我们对本协议任何条款随时所做的任何修改。我们有权随时修改本协议，<strong>如您继续使用“文心”，将视为您已接受了百度公司对本协议相关条款所做的修改。如您不接受修改后的协议，请您立即停止使用本服务。</strong>
            </p>

            <p>北京百度网讯科技有限公司</p>
            <p>更新日期：2026年1月20日</p>
            <p>生效日期：2026年1月20日</p>
        </div>
        `;
        const container = document.querySelector('#app');
        container.innerHTML = content;
    